export const MobileVector = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg width="31" height="42" viewBox="0 0 31 42" fill="none">
    <path
      d="M23.4167 27.893L21.9417 26.418L26.2938 22.043H14.0417V19.9596H26.2917L21.9417 15.5846L23.4167 14.1096L30.3083 21.0013L23.4167 27.893ZM3.86458 41.8346C2.93958 41.8346 2.14792 41.5048 1.48958 40.8451C0.829861 40.1881 0.5 39.3971 0.5 38.4721V3.53255C0.5 2.60755 0.829861 1.81589 1.48958 1.15755C2.14792 0.49783 2.93958 0.167969 3.86458 0.167969H22.1354C23.0604 0.167969 23.8521 0.49783 24.5104 1.15755C25.1701 1.81589 25.5 2.60755 25.5 3.53255V10.4242H23.4167V7.45964H2.58333V34.543H23.4167V31.5784H25.5V38.4492C25.5 39.3937 25.1701 40.1944 24.5104 40.8513C23.8521 41.5069 23.0604 41.8346 22.1354 41.8346H3.86458Z"
      fill={strokeColor}
    />
  </svg>
);
